export class MouseTrack {
  x: number;
  y: number;
}
